import { useEffect, useMemo } from 'react'
import { useMap } from 'react-leaflet'
import { LeafletPlace } from '../../../definitions'
import { composePlacesBounds } from '../../../local/utils'
import PlaceMarker from './PlaceMarker'

/**
 * @typedef {Object} LeafletMapPlacesProps
 * @property {LeafletPlace[]} places An array of Leaflet places to draw in map.
 * @property {number=} selectedPlaceId ID of a place that should be highlighted.
 */

/**
 * Renders LeafletMap places markers with information popup.
 * @param {LeafletMapPlacesProps} props
 * @return {JSX.Element}
 */
const LeafletMapPlaces = ({ places, selectedPlaceId }) => {
  const map = useMap()

  useEffect(() => {
    // When specific place is selected don't affect the bounds focus due to
    // desired zoom on selected place is deepest in order to focus the place.
    if (!selectedPlaceId) {
      const placeBounds = composePlacesBounds(places)
      map.invalidateSize()
      map.fitBounds(placeBounds)
    }
  }, [places, selectedPlaceId])

  // For search result detail map there is a problem on render in Drupal
  // that needs re-rendering once the places component mounts.
  useEffect(() => {
    if (places.length === 1) {
      map.invalidateSize()
    }
  }, [])

  const PlaceMarkers = places.map((place) => {
    const isSelected = selectedPlaceId === Number(place.id)
    return (
      <PlaceMarker
        key={place.id}
        place={place}
        isSelected={isSelected}
      />
    )
  })

  return <>{PlaceMarkers}</>
}

export default LeafletMapPlaces
